
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2015_8456)"}},[_c('path',{attrs:{"d":"M16.75 1.15l-.9-.9L8.5 7.6 1.15.25l-.9.9L7.6 8.5.25 15.85l.9.9L8.5 9.4l7.35 7.35.9-.9L9.4 8.5l7.35-7.35z","fill":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2015_8456"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.25 .25)","d":"M0 0h16.5v16.5H0z"}})])])])
          )
        }
      }
    